import React from 'react';

import { Container } from '../../atoms/Container/Container';
import childrenOfTypes from '../../utils/childrenOfTypes';
import RenderChildren from '../../utils/RenderChildren/RenderChildren';
import parseChildren from '../../utils/parseChildren';

const BreadcrumbContent = class extends RenderChildren {};

const Breadcrumb = ({ children: rawChildren }) => {
  const children = parseChildren(rawChildren);
  const content = children.findByType(BreadcrumbContent);
  return (
    <Container fluid className="Breadcrumb">
      <Container.Row>
        <Container.Col xs={12}>
          <div className="content">
            {content}
          </div>
        </Container.Col>
      </Container.Row>
    </Container>
  );
};

Breadcrumb.Content = BreadcrumbContent;

Breadcrumb.propTypes = {
  /** elements to render wrapped in Breadcrumb.Content */
  children: childrenOfTypes(BreadcrumbContent).isRequired,
};

export default Breadcrumb;
